import React from 'react';
import { AlertTriangle } from 'lucide-react';

// CR27-34: legal reminder on every medication screen — the app does not replace the signed paper chart.
export default function MedicationChartNotice() {
  return (
    <div role="note" className="flex items-start gap-2 rounded-md border border-red-300 bg-red-50 px-3 py-2 text-sm font-medium text-red-700" data-testid="medication-chart-notice">
      <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" aria-hidden="true" />
      <span>This app is not a medication chart. A signed paper medication chart is legally required.</span>
    </div>
  );
}
